export const createIndividualDepositCalcRepository = (appFetch) => {
    return {
        deposits(options) {
            return appFetch.get('/api/v1/calculators/deposit/individual', options);
        },
        deposit(slug, options) {
            return appFetch.get(`$/api/v1/calculators/deposit/individual/${slug}`, options);
        },
    };
};
